define("shared/components/shared/typeform-survey-trigger", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _tracking, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{#if (has-block)}}
    {{yield (hash toggleSurveyModal=this.toggleSurveyModal)}}
  {{else}}
    {{#if @surveyDescription}}
      <p class="u--text--light u--inline qa--survey_text">
        {{svg-jar "comment" class="o--icon"}}
        {{@surveyDescription}}
      </p>
    {{/if}}
    <Shared::Ui::Button
      @class={{concat-classes "qa--survey_link" @buttonClasses}}
      @onClick={{this.toggleSurveyModal}}
      @text={{@buttonText}}
      @variant={{or @variant "unstyled"}}
      data-test-id="let-us-know"
    />
  {{/if}}
  
  {{! Survey Modal }}
  {{#if (or this.showSurveyModal @showSurveyModalFromExternal)}}
    <Shared::Portal @destinationElement="root-portal">
      <Shared::Modal @close={{this.toggleSurveyModal}} data-test-id="typeform-survey" as |modal|>
        <modal.card @portrait={{true}} class="u--p__b__0 {{@modalQaClass}}">
          <modal.card-body>
            <div class="u--text--center u--text--bold">
              <div
                class="cLB--surveyModal"
                data-tf-hidden="plan={{this.planName}},email={{this.email}},bestdescribes={{this.bestDescribes}},businessmodel={{this.businessModel}},slug={{@slug}},userid={{this.userId}}{{@additionalFields}}"
                data-tf-hide-footer
                data-tf-hide-headers
                data-tf-inline-on-mobile="true"
                data-tf-on-submit="onsubmit"
                data-tf-opacity="0"
                data-tf-widget={{@formId}}
              >
              </div>
              <script src="//embed.typeform.com/next/embed.js"></script>
            </div>
          </modal.card-body>
        </modal.card>
      </Shared::Modal>
    </Shared::Portal>
  {{/if}}
  */
  {
    "id": "M4WVDQRo",
    "block": "[[[41,[48,[30,11]],[[[1,\"  \"],[18,11,[[28,[37,3],null,[[\"toggleSurveyModal\"],[[30,0,[\"toggleSurveyModal\"]]]]]]],[1,\"\\n\"]],[]],[[[41,[30,1],[[[1,\"    \"],[10,2],[14,0,\"u--text--light u--inline qa--survey_text\"],[12],[1,\"\\n      \"],[1,[28,[35,4],[\"comment\"],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n      \"],[1,[30,1]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[8,[39,5],[[24,\"data-test-id\",\"let-us-know\"]],[[\"@class\",\"@onClick\",\"@text\",\"@variant\"],[[28,[37,6],[\"qa--survey_link\",[30,2]],null],[30,0,[\"toggleSurveyModal\"]],[30,3],[28,[37,7],[[30,4],\"unstyled\"],null]]],null],[1,\"\\n\"]],[]]],[1,\"\\n\"],[41,[28,[37,7],[[30,0,[\"showSurveyModal\"]],[30,5]],null],[[[1,\"  \"],[8,[39,8],null,[[\"@destinationElement\"],[\"root-portal\"]],[[\"default\"],[[[[1,\"\\n    \"],[8,[39,9],[[24,\"data-test-id\",\"typeform-survey\"]],[[\"@close\"],[[30,0,[\"toggleSurveyModal\"]]]],[[\"default\"],[[[[1,\"\\n      \"],[8,[30,6,[\"card\"]],[[16,0,[29,[\"u--p__b__0 \",[30,7]]]]],[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n        \"],[8,[30,6,[\"card-body\"]],null,null,[[\"default\"],[[[[1,\"\\n          \"],[10,0],[14,0,\"u--text--center u--text--bold\"],[12],[1,\"\\n            \"],[10,0],[14,0,\"cLB--surveyModal\"],[15,\"data-tf-hidden\",[29,[\"plan=\",[30,0,[\"planName\"]],\",email=\",[30,0,[\"email\"]],\",bestdescribes=\",[30,0,[\"bestDescribes\"]],\",businessmodel=\",[30,0,[\"businessModel\"]],\",slug=\",[30,8],\",userid=\",[30,0,[\"userId\"]],[30,9]]]],[14,\"data-tf-hide-footer\",\"\"],[14,\"data-tf-hide-headers\",\"\"],[14,\"data-tf-inline-on-mobile\",\"true\"],[14,\"data-tf-on-submit\",\"onsubmit\"],[14,\"data-tf-opacity\",\"0\"],[15,\"data-tf-widget\",[30,10]],[12],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,\"script\"],[14,\"src\",\"//embed.typeform.com/next/embed.js\"],[12],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"]],[]]]]],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"]],[6]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[]],null]],[\"@surveyDescription\",\"@buttonClasses\",\"@buttonText\",\"@variant\",\"@showSurveyModalFromExternal\",\"modal\",\"@modalQaClass\",\"@slug\",\"@additionalFields\",\"@formId\",\"&default\"],false,[\"if\",\"has-block\",\"yield\",\"hash\",\"svg-jar\",\"shared/ui/button\",\"concat-classes\",\"or\",\"shared/portal\",\"shared/modal\"]]",
    "moduleName": "shared/components/shared/typeform-survey-trigger.hbs",
    "isStrictMode": false
  });
  let TypeformSurveyTriggerComponent = _exports.default = (_class = class TypeformSurveyTriggerComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _initializerDefineProperty(this, "auth", _descriptor2, this);
      _initializerDefineProperty(this, "cache", _descriptor3, this);
      _initializerDefineProperty(this, "segment", _descriptor4, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor5, this);
      _initializerDefineProperty(this, "showSurveyModal", _descriptor6, this);
      const cacheKey = `${this.auth.currentAccount.id}_${this.args.formId}`;
      const submitSurvey = event => {
        if (event.preventDefault) {
          event.preventDefault();
        } else {
          this.toggleSurveyModal();
          if (this.args.successDescription) {
            this.alerts.success(this.args.successDescription, {
              ...(this.args.successTitle && {
                title: this.args.successTitle
              })
            });
          }
          this.segment.track('submitted-survey', {
            area: this.args.location,
            ...(this.args.slug && {
              slug: this.args.slug
            })
          });
          this.cache.add(cacheKey, {
            isFormSubmitted: true
          }, {
            expiry: this.cache.expiry(30, 'days'),
            persist: true
          });
        }
      };
      window.onsubmit = submitSurvey;
    }
    willDestroy() {
      super.willDestroy();
      window.onsubmit = null;
    }
    get bestDescribes() {
      return this.auth.currentAccount.bestDescribes ?? '';
    }
    get businessModel() {
      return this.auth.currentAccount.mainProfile?.businessModel ?? '';
    }
    get email() {
      return this.user.email;
    }
    get planName() {
      return this.subscriptions.planType;
    }
    get user() {
      return this.auth.currentUserModel;
    }
    get userId() {
      return this.user.id;
    }
    toggleSurveyModal() {
      if (this.args.toggleFromExternal) {
        this.args.toggleFromExternal();
      } else {
        this.showSurveyModal = !this.showSurveyModal;
      }
      this.segment.track('opened-survey', {
        area: this.args.location,
        ...(this.args.slug && {
          slug: this.args.slug
        })
      });
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "cache", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "showSurveyModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "toggleSurveyModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleSurveyModal"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, TypeformSurveyTriggerComponent);
});